import styled from 'styled-components';

const Button = styled.button`
  display: inline-block;
  padding: 1em 0.7em;
  text-transform: uppercase;
  text-align: center;
  color: ${props => props.theme.colors.purple};
  background-color: ${props => props.theme.colors.pink};
  letter-spacing: 0.2em;
  font-family: "ocr-a-std", monospace;
  font-weight: 600;
  cursor: pointer;
  border: none;

  &:hover {
    background-color: ${props => props.theme.colors.purple};
    color: ${props => props.theme.colors.pink};
  }

  &:disabled {
    background-color: #ccc;
    color: #000;
  }
`;

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button.jsx